var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQGiftTeens = function SvgQGiftTeens(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.263,
    height: 21.809,
    x: 4.371,
    y: 6.188,
    fill: "#4495FF",
    rx: 2.181
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4DEFF",
    d: "M13.816 6.188h4.362v21.809h-4.362z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4DEFF",
    d: "M8.73 2.813c0-.487.47-.836.936-.696L16 4.017l6.334-1.9c.466-.14.936.209.936.696v3.385H8.73z"
  })));
};
export { SvgQGiftTeens as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNC4zNzEwOSIgeT0iNi4xODc1IiB3aWR0aD0iMjMuMjYzIiBoZWlnaHQ9IjIxLjgwOTEiIHJ4PSIyLjE4MDkxIiBmaWxsPSIjNDQ5NUZGIi8+CjxyZWN0IHg9IjEzLjgxNjQiIHk9IjYuMTg3NSIgd2lkdGg9IjQuMzYxODIiIGhlaWdodD0iMjEuODA5MSIgZmlsbD0iI0I0REVGRiIvPgo8cGF0aCBkPSJNOC43MzA0NyAyLjgxMzAxQzguNzMwNDcgMi4zMjYwNCA5LjE5OTkgMS45NzY3NyA5LjY2NjMzIDIuMTE2N0wxNi4wMDAyIDQuMDE2ODVMMjIuMzM0IDIuMTE2N0MyMi44MDA0IDEuOTc2NzcgMjMuMjY5OSAyLjMyNjA0IDIzLjI2OTkgMi44MTMwMVY2LjE5Nzc1SDguNzMwNDdWMi44MTMwMVoiIGZpbGw9IiNCNERFRkYiLz4KPC9zdmc+Cg==";